import { getPercentageAdjustment } from '..';

/**
 * @method getNextLocationPercentage
 */
const getNextLocationPercentage = (frame, percentageScrolled) => {
  // get the percentage amount to scroll the document
  const percentageAdjustment = getPercentageAdjustment(frame);

  // calculate the next percentage of document
  const newPercentageOfDocument = Math.min(
    percentageScrolled + percentageAdjustment,
    1,
  );

  return newPercentageOfDocument;
};

export default getNextLocationPercentage;
